import * as actionTypes from '../redux/actionTypes';

const initialState = {
  tree: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.VANPOOL_AGGREGATES_LOADED:
      return { ...state, ...action.data };
    default:
      return state;
  }
};
